import { createContext, useContext } from 'react';

export const ThemeContext = createContext({
  customizations: {},
  setCustomization: () => {},
});

ThemeContext.displayName = 'AgentThemeContext';

export const useThemeContext = () => useContext(ThemeContext);

export const useCustomizations = () => {
  const themeContext = useContext(ThemeContext);
  return themeContext.customizations ?? {};
};

export function useFeatureFlag(flagName) {
  const customizations = useCustomizations();
  return customizations[flagName];
}
